const avatarLetterFromNameOrEmail = (firstname, email) =>
  firstname
    ? firstname.charAt(0)?.toUpperCase()
    : email?.charAt(0)?.toUpperCase()

export default avatarLetterFromNameOrEmail
